module.exports = __webpack_public_path__ + "img/Glowkit-AdditionalProps.a2ecd10f.jpg";